const default_locale = 'en_GB'

const locales = [
  {key: default_locale, translated: 'English (UK)'},
  {key: 'sv_SE', translated: 'Svenska'},
  {key: 'pt_BR', translated: 'Português (BR)'},
  {key: 'de_DE', translated: 'Deutsch'},
]

export { locales, default_locale }
